module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container table-data"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称",
      "prop": "school_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.school_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "school_id", $$v)
      },
      expression: "queryForm.school_id"
    }
  }, _vm._l((_vm.schoolList), function(item) {
    return _c('el-option', {
      key: item.school_id,
      attrs: {
        "label": item.school_name,
        "value": item.school_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_vm._l((_vm.tableColumn), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.id,
        "label": item.name,
        "show-overflow-tooltip": true,
        "width": item.width,
        "fixed": item.fixed
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.formatter) ? _c('span', [_vm._v(_vm._s(item.formatter(scope.row)))]) : _c('span', [_vm._v(_vm._s(scope.row[item.id]))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "门店二维码",
      "show-overflow-tooltip": true,
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "primary cursor",
          on: {
            "click": function($event) {
              return _vm.loadShopCode(scope.row)
            }
          }
        }, [_vm._v("门店二维码下载")])]
      }
    }])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.page,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bfe31a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/headOffice/shop/list.vue
// module id = 855
// module chunks = 0